import React from 'react';
import classNames from 'classnames';
import { IconChevronProps, IconProps } from './Icons.types';
import './Icons.scss';

/**
 * Icon Components
 * Following DDD principles - UI layer components
 *
 * Usage:
 * <IconDashboard isActive={true} />
 * <IconCustomers isBlack={true} isRelative={true} />
 */

/**
 * IconCustomers - Example icon component
 * Shows customers icon with different states (gray/white/black)
 */
export const IconCustomers = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-customers-gray': !props.isBlack && !props.isActive,
        'icon-customers-white': !props.isBlack && props.isActive,
        'icon-customers-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconDashboard - Dashboard icon
 */
export const IconDashboard = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-dashboard-gray': !props.isActive,
        'icon-dashboard-black': props.isActive,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconAnalytics - Analytics icon
 */
export const IconAnalytics = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-analytics-gray': !props.isBlack && !props.isActive,
        'icon-analytics-white': !props.isBlack && props.isActive,
        'icon-analytics-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconUsers - Users icon
 */
export const IconUsers = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-users-gray': !props.isBlack && !props.isActive,
        'icon-users-white': !props.isBlack && props.isActive,
        'icon-users-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconOrders - Orders icon
 */
export const IconOrders = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-orders-gray': !props.isBlack && !props.isActive,
        'icon-orders-white': !props.isBlack && props.isActive,
        'icon-orders-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconCategories - Categories icon
 */
export const IconCategories = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-categories-gray': !props.isBlack && !props.isActive,
        'icon-categories-white': !props.isBlack && props.isActive,
        'icon-categories-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconRoles - Roles icon
 */
export const IconRoles = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-roles-gray': !props.isBlack && !props.isActive,
        'icon-roles-white': !props.isBlack && props.isActive,
        'icon-roles-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconReports - Reports icon
 */
export const IconReports = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-reports-gray': !props.isBlack && !props.isActive,
        'icon-reports-white': !props.isBlack && props.isActive,
        'icon-reports-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconNotifications - Notifications icon
 */
export const IconNotifications = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-notifications-gray': !props.isBlack && !props.isActive,
        'icon-notifications-white': !props.isBlack && props.isActive,
        'icon-notifications-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconSubscription - Subscription icon
 */
export const IconSubscription = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-subscription-gray': !props.isBlack && !props.isActive,
        'icon-subscription-white': !props.isBlack && props.isActive,
        'icon-subscription-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconAdmins - Admins icon
 */
export const IconAdmins = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-admins-gray': !props.isBlack && !props.isActive,
        'icon-admins-white': !props.isBlack && props.isActive,
        'icon-admins-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconSettings - Settings icon
 */
export const IconSettings = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-settings-gray': !props.isBlack && !props.isActive,
        'icon-settings-white': !props.isBlack && props.isActive,
        'icon-settings-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconFaq - FAQ icon
 */
export const IconFaq = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-faq-gray': !props.isBlack && !props.isActive,
        'icon-faq-white': !props.isBlack && props.isActive,
        'icon-faq-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconCompanies - Companies icon
 */
export const IconCompanies = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-companies-gray': !props.isBlack && !props.isActive,
        'icon-companies-white': !props.isBlack && props.isActive,
        'icon-companies-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconProducts - Products icon
 */
export const IconProducts = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-products-gray': !props.isBlack && !props.isActive,
        'icon-products-white': !props.isBlack && props.isActive,
        'icon-products-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconChevron - Chevron icon (16x16)
 * Use isOpen / direction='up' to flip 180deg via CSS transition
 */
export const IconChevron = (props: IconChevronProps & { isOpen?: boolean }) => {
  const isUp = props.direction === 'up' || props.isOpen;
  return (
    <i
      className={classNames(
        {
          icon: true,
          'icon-chevron': true,
          'icon-chevron--up': isUp,
          relative: props.isRelative,
        },
        props.className,
      )}
    />
  );
};

/**
 * IconLogoTypeSmall - Small LogoType (174x32)
 * Brand logo for navigation and headers
 */
export const IconLogoTypeSmall = (props: IconProps) => {
  return (
    <i
      className={classNames(
        {
          icon: true,
          'icon-logotype-small': true,
          relative: props.isRelative,
        },
        props.className
      )}
    ></i>
  );
};

// ============================================================================
// ACTION ICONS
// ============================================================================

export const IconEdit = (props: IconProps) => {
  return (
    <i
      className={classNames(
        {
          icon: true,
          'icon-edit-gray': !props.isBlack && !props.isActive,
          'icon-edit-white': !props.isBlack && props.isActive,
          'icon-edit-black': props.isBlack,
          relative: props.isRelative,
        },
        props.className
      )}
    ></i>
  );
};

export const IconFilter = (props: IconProps) => {
  const isWhite = props.isActive || props.className?.includes('white');
  return (
    <i
      className={classNames(
        {
          icon: true,
          'icon-filter-gray': !props.isBlack && !isWhite,
          'icon-filter-white': isWhite,
          'icon-filter-black': props.isBlack,
          relative: props.isRelative,
        },
        props.className
      )}
    ></i>
  );
};

export const IconPlus = (props: IconProps) => {
  const isWhite = props.isActive || props.className?.includes('white');
  return (
    <i
      className={classNames(
        {
          icon: true,
          'icon-plus-gray': !props.isBlack && !isWhite,
          'icon-plus-white': isWhite,
          'icon-plus-black': props.isBlack,
          relative: props.isRelative,
        },
        props.className
      )}
    ></i>
  );
};

export const IconRemove = (props: IconProps) => {
  return (
    <i
      className={classNames(
        {
          icon: true,
          'icon-remove-gray': !props.isBlack && !props.isActive,
          'icon-remove-white': !props.isBlack && props.isActive,
          'icon-remove-black': props.isBlack,
          relative: props.isRelative,
        },
        props.className
      )}
    ></i>
  );
};

export const IconTrash = (props: IconProps) => {
  return (
    <i
      className={classNames(
        {
          icon: true,
          'icon-trash-gray': !props.isBlack && !props.isActive,
          'icon-trash-white': !props.isBlack && props.isActive,
          'icon-trash-black': props.isBlack,
          relative: props.isRelative,
        },
        props.className
      )}
    ></i>
  );
};

// Add more icon components as needed following the same pattern
